import React from "react";
import { Wrapper } from "./Roles.styled";
import {
  Row,
  Col,
  Button,
  Modal,
  SuccessNotification,
  Spin,
} from "../../components/common";
import { callGetApi, callPostApi, callPutApi } from "utils/api";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import AddRole from "components/pageSection/Roles/AddRole";
import { getUserPermissions } from "utils/text";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { EditOutlined } from "@ant-design/icons";

const Roles = () => {
  const history = useHistory();
  const [apiLoader, setApiLoader] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [addRole, setAddRole] = useState({
    role: "",
    priority: 1
  });

  // update role
  const onEnd = (result) => {
    if (!result.destination) {
      return;
    }
    // setApiLoader(true);

    setRolesData(
      reorder(rolesData, result.source.index, result.destination.index)
    );
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    updateRoleApi(result);
    return result;
  };
  const updateRoleApi = (list) => {
    callPutApi(
      "/roles",
      { list },
      onSuccessUpdateRoleApi,
      onFailUpdateRoleApi
    );
  };
  const onSuccessUpdateRoleApi = async (data) => {
    await callGetRolesApi();
    SuccessNotification("Roles has been updated");
  };
  const onFailUpdateRoleApi = (err) => {
    console.log(err);
  };

  // create new role
  const onPostAddRoleApi = (data) => {
    setIsLoading(true);
    callPostApi(
      "/roles",
      data,
      onSuccessAddRoleApi,
      onFailedAddRoleApi
    );
  };
  const onSuccessAddRoleApi = (data) => {
    SuccessNotification("Role Added ");
    setIsLoading(false);
    callGetRolesApi();
  };
  const onFailedAddRoleApi = (err) => {
    setIsLoading(false);
  };

  // get role
  const onSuccessGetRole = (data) => {
    setRolesData(data);
    setApiLoader(false);
  };
  const onFailGetRole = (err) => {
    console.log(err);
  };
  const callGetRolesApi = () => {
    callGetApi("/roles", onSuccessGetRole, onFailGetRole);
  };

  useEffect(() => {
    callGetRolesApi();
  }, []);

  return (
    <Wrapper>
      {getUserPermissions("add-role-action") && (
        <Row style={{ paddingRight: "24px" }}>
          <Col span={24}>
            <Button
              title="Add Role"
              className="add-level-button"
              onClick={() => {
                setConfirm(true);
              }}
            />
          </Col>
        </Row>
      )}

      {apiLoader ? (
        <div style={{ display: "flex", justifyContent: "center", flex: 1 }}>
          <Spin />
        </div>
      ) : (
        <div className="main-section">
          <DragDropContext onDragEnd={onEnd}>
            <Droppable droppableId="dropableid">
              {(provided, snapshot) => (
                <div ref={provided.innerRef}>
                  {rolesData?.map((item, index) => (
                    <Draggable
                      draggableId={item.id}
                      key={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div className="container-one">
                          <div
                            className=""
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div className="button">
                                <div />
                                <span> {item?.role} </span>
                                <div />
                              </div>
                              <div>
                                <EditOutlined
                                  className="edit-icon"
                                  onClick={() => {
                                    history.push(`/role/${item?._id}`);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      )}
      <Modal
        className="main-modal"
        isOpen={confirm}
        footer={false}
        toggleModal={() => {
          setConfirm(false);
        }}
      >
        <AddRole
          addRole={addRole}
          setAddRole={setAddRole}
          onPostAddRoleApi={onPostAddRoleApi}
          setConfirm={setConfirm}
          isLoading={isLoading}
        />
      </Modal>
    </Wrapper>
  );
};

export default Roles;
